module.exports = __webpack_public_path__ + "img/f3a6279.png";